module.exports = __webpack_public_path__ + "img/image.8560a162.png";